// import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
// import { isEmailAddressDecoratedBrand } from 'owa-persona';
export default function shouldShowBrandDecoration(singleLastSenderSMTP) {
    return false;
    // Temporarily disable brand decorations in the list view pending design review.
    // See work item 31530
    /*return (
        isMailFeatureEnabled('rp-brandDecorations') &&
        singleLastSenderSMTP &&
        isEmailAddressDecoratedBrand(singleLastSenderSMTP)
    );*/
}
//# sourceMappingURL=shouldShowBrandDecoration.js.map